<!---------------------------------------------------------- FFL Search --------------------------------------------------------->

<!--Header-->
<div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0">
  <div class="modal-title">
    <h4>FFL Search</h4>
  </div>
  <button type="button" class="close-btn" style="margin-left: auto" (click)="closeModalClick()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!-- Body -->
<div class="modal-body pb-4">
  <!-- Last FFLs Used -->
  <div class="row card_row mb-2">
    @if (sharedService.last_ffls_used.length > 0) {
    <span class="mb-1" style="text-align: left; font-weight: bold; color: #e0e0e0">Last FFLs Used</span>
    }
    <div class="ffl-card-grid">
      @for (ffl of sharedService.last_ffls_used; track ffl; let i = $index) {
      <div class="card modern-card ffl-card ffls-last-used" role="button" tabindex="0"
        (click)="onCardClick($event, ffl)" (dblclick)="onCardDoubleClick($event, ffl)"
        (keyup.enter)="fflDoubleClicked(ffl)" (keyup.space)="fflDoubleClicked(ffl)"
        (contextmenu)="onRightClick($event, ffl)">
        <div class="card-body">
          <div class="card-item" style="display: flex; justify-content: space-between; align-items: center;">
            <div>
              <span class="label">FFL:</span>
              <span class="value">{{ ffl.ffl }}</span>
            </div>
            @if (ffl.certified_ffl_blob_name) {
            <i class="fa-solid fa-paperclip" style="cursor: pointer; color: #2399e5; font-size: 1.1em;"
              title="View License" (click)="viewAttachment($event, ffl.id)"></i>
            }
          </div>
          <div class="card-item">
            <div>
              <span class="label">Legal:</span>
              <span class="value">{{ ffl.legal_name }}</span>
            </div>
          </div>
          <div class="card-item">
            <div>
              <span class="label">DBA:</span>
              <span class="value">{{ ffl.business_name }}</span>
            </div>
          </div>
          <div class="card-item" [ngStyle]="getStyleForFFL(ffl)">
            <div>
              <span class="label" [style.color]="isExpired(ffl) ? '#f87171' : ''">{{ isExpired(ffl) ? "Expired:" :
                "Expires:" }}</span>
              <span class="value">{{
                ffl.expiration_date | slice: 0 : 10
                }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- FFLs Frequently Used -->
  <div class="row card_row mb-2 mt-4">
    @if (sharedService.ffls_frequently_used.length > 0) {
    <span class="mb-1" style="text-align: left; font-weight: bold; color: #e0e0e0">FFLs Frequently Used</span>
    }
    <div class="ffl-card-grid">
      @for (
      ffl of sharedService.ffls_frequently_used;
      track ffl;
      let i = $index
      ) {
      <div class="card modern-card ffl-card ffls-most-used" role="button" tabindex="0"
        (click)="onCardClick($event, ffl)" (dblclick)="onCardDoubleClick($event, ffl)"
        (keyup.enter)="fflDoubleClicked(ffl)" (keyup.space)="fflDoubleClicked(ffl)"
        (contextmenu)="onRightClick($event, ffl)">
        <div class="card-body">
          <div class="card-item" style="display: flex; justify-content: space-between; align-items: center;">
            <div>
              <span class="label">FFL:</span>
              <span class="value">{{ ffl.ffl }}</span>
            </div>
            @if (ffl.certified_ffl_blob_name) {
            <i class="fa-solid fa-paperclip" style="cursor: pointer; color: #2399e5; font-size: 1.1em;"
              title="View License" (click)="viewAttachment($event, ffl.id)"></i>
            }
          </div>
          <div class="card-item">
            <div>
              <span class="label">Legal:</span>
              <span class="value">{{ ffl.legal_name }}</span>
            </div>
          </div>
          <div class="card-item">
            <div>
              <span class="label">DBA:</span>
              <span class="value">{{ ffl.business_name }}</span>
            </div>
          </div>
          <div class="card-item" [ngStyle]="getStyleForFFL(ffl)">
            <div>
              <span class="label" [style.color]="isExpired(ffl) ? '#f87171' : ''">{{ isExpired(ffl) ? "Expired:" :
                "Expires:" }}</span>
              <span class="value">{{
                ffl.expiration_date | slice: 0 : 10
                }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Full List -->
  <div class="row mb-2">
    <span class="mb-1" style="text-align: left; font-weight: bold; color: #e0e0e0">Full List</span>
    <ag-grid-angular #grid id="dispo_list" class="modern-grid" style="width: 100%; height: 35vh"
      [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
      [context]="{ FflSearchComponent: this }" [rowData]="this.sharedService.ffl_list"
      [overlayLoadingTemplate]="overlayLoadingTemplate" [animateRows]="true" [components]="components"
      [enableBrowserTooltips]="true" [pagination]="true"
      [paginationPageSize]="sharedService.default_pagination_page_size" (rowDoubleClicked)="onRowDoubleClicked($event)"
      (cellContextMenu)="onCellContextMenu($event)"></ag-grid-angular>
  </div>
</div>

<!-- Context Menu -->
@if ((menuState$ | async)?.showMenu) {
<div class="custom-context-menu" [style.top.px]="(menuState$ | async)?.menuTop"
  [style.left.px]="(menuState$ | async)?.menuLeft" (mouseenter)="onMenuMouseEnter()" (mouseleave)="onMenuMouseLeave()">
  <div (click)="editFFL()">Edit FFL</div>
  @if (isExpired(contextMenuRow)) {
  <div (click)="requestNewFFL()">Request Updated FFL</div>
  }
</div>
}